import { useEffect } from 'react';

interface SeoMetaProps {
  title: string;
  description: string;
  path: string;
}

const SITE_URL = 'https://premios.novagob.org';

const setMetaContent = (selector: string, attr: string, value: string) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

/**
 * Actualiza el <title> y las metaetiquetas SEO/OG/Twitter por página,
 * mutando las etiquetas ya presentes en public/index.html en vez de
 * insertar duplicados (React no toma "propiedad" de etiquetas estáticas
 * que no ha renderizado él mismo).
 */
const SeoMeta: React.FC<SeoMetaProps> = ({ title, description, path }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    setMetaContent('meta[name="description"]', 'content', description);
    setMetaContent('link[rel="canonical"]', 'href', url);
    setMetaContent('meta[property="og:title"]', 'content', title);
    setMetaContent('meta[property="og:description"]', 'content', description);
    setMetaContent('meta[property="og:url"]', 'content', url);
    setMetaContent('meta[name="twitter:title"]', 'content', title);
    setMetaContent('meta[name="twitter:description"]', 'content', description);
  }, [title, description, path]);

  return null;
};

export default SeoMeta;
